import axiosInstance from "../../axios";

// Action Types
export const PRODUCT_LISTING_REQUEST = 'PRODUCT_LISTING_REQUEST';
export const PRODUCT_LISTING_SUCCESS = 'PRODUCT_LISTING_SUCCESS';
export const PRODUCT_LISTING_FAILURE = 'PRODUCT_LISTING_FAILURE';

// Action Creators
export const productListingRequest = () => ({
    type: PRODUCT_LISTING_REQUEST,
});

export const productListingSuccess = (products, subCategoryName) => ({
    type: PRODUCT_LISTING_SUCCESS,
    payload: products,
    subCategoryName,
});

export const productListingFailure = (error) => ({
    type: PRODUCT_LISTING_FAILURE,
    payload: error,
});

// Thunk Action Creator
export const fetchProductListing = (subCategoryId, subCategoryName) => async (dispatch) => {
    try {
        dispatch(productListingRequest());

        console.log(`product/subcat/${subCategoryId}`);
        const response = await axiosInstance.get(`product/subcat/${subCategoryId}`);

        dispatch(productListingSuccess(response.data.data, subCategoryName));
    } catch (error) {
        console.log(error);
        let errorMessage = 'Unknown error';

        if (error instanceof Error) {
            errorMessage = error.message;
        }

        dispatch(productListingFailure(errorMessage));
    }
};

// Initial State
const initialState = {
    loading: false,
    products: [],
    subCategoryName: 'Products',
    categoryName: '',
    error: null
};

// Reducer
export const productListingReducer = (state = initialState, action) => {
    switch (action.type) {
        case PRODUCT_LISTING_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case PRODUCT_LISTING_SUCCESS:
            const products = action.payload || [];
            const categoryName = products.length > 0 ? products[0].category : '';
            const subCategoryName = action.subCategoryName ||
                (products.length > 0 ? products[0].subCategory : 'Products');

            return {
                ...state,
                loading: false,
                products: products,
                subCategoryName,
                categoryName,
                error: null
            };

        case PRODUCT_LISTING_FAILURE:
            return {
                ...state,
                loading: false,
                products: [],
                error: action.payload
            };

        default:
            return state;
    }
}; 